// Language (/settings/language): a radio selector between the system default,
// English and Russian. The choice applies immediately (no restart) and is
// persisted to the KV store; on Android it also drives the native per-app
// locale (IncomingCallActivity + notification strings) via changeLanguage.

import type { ReactNode } from 'react';
import { useT, useLanguageSetting, useChangeLanguage, type LangSetting } from '../../i18n/index.js';
import { Section, SettingsSubScreen } from './chrome.js';

const OPTIONS: ReadonlyArray<{ value: LangSetting; labelKey: 'language.system' | 'language.en' | 'language.ru' }> = [
  { value: 'system', labelKey: 'language.system' },
  { value: 'en', labelKey: 'language.en' },
  { value: 'ru', labelKey: 'language.ru' },
];

export function LanguageSettingsScreen(): ReactNode {
  const t = useT();
  const setting = useLanguageSetting();
  const changeLanguage = useChangeLanguage();

  return (
    <SettingsSubScreen section="language" title={t('language.title')}>
      <Section title={t('language.title')}>
        <fieldset className="flex flex-col gap-1">
          <legend className="sr-only">{t('language.title')}</legend>
          {OPTIONS.map((option) => (
            <label
              key={option.value}
              className="flex min-h-touch items-center gap-3 text-sm text-ink"
            >
              <input
                type="radio"
                name="app-language"
                value={option.value}
                checked={setting === option.value}
                onChange={() => void changeLanguage(option.value)}
                className="h-5 w-5"
              />
              {t(option.labelKey)}
            </label>
          ))}
        </fieldset>
      </Section>
    </SettingsSubScreen>
  );
}
